
// React Imports
import {useSelector} from "react-redux";
import * as React from "react";

// Mui Imports
import {Stack} from "@mui/material";

// App Imports
import SeasonContractStatsGrid from "../WorkStats/SeasonContractStats";
import EpisodeContractStatsGrid from "../WorkStats/EpisodeContractStats";
import GuildContractStatsGrid from "../WorkStats/GuildContractStats";
import WorkQueueFolders from "../Folders/WorkQueueFolders";
import WorkQueueCDPGrid from "../ContractDataPoints/WorkQueueCDPGrid";
import Box from "@mui/material/Box";
import WorkQueueCdpPanel from "../ContractDataPoints/WorkQueueCdpPanel";
import CdpvPivotDrawer from "../Pivot/CdpvPivotDrawer";
import CdpvMegaPivotDrawer from "../Pivot/CdpvMegaPivotDrawer";
import CdpvMegaDatePivotDrawer from "../Pivot/CdpvMegaDatePivotDrawer";



export default function WorkQueueBodyRight(props) {

    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const  selectorTitleId = useSelector((state) => state.workQueueSlc.value.propertyDropdownTitleId);
    const selectorStatsGridDisplay = useSelector((state) => state.contractStatsControlsSlc.value.gridDisplay);
    const selectorCdpvPivotState = useSelector((state) => state.workQueueSlc.value.cdpvPivotState);
    const selectorCdpvMegaPivotState = useSelector((state) => state.workQueueSlc.value.cdpvMegaPivotState);
    const selectorCdpvMegaDatePivotState = useSelector((state) => state.workQueueSlc.value.cdpvMegaDatePivotState);
    const selectorContractFoldersDisplay = useSelector((state) => state.workQueueSlc.value.contractFoldersDisplay);

    return(


        <div>
            <Box sx={{height: 10}}/>

            {
                (selectorContractId === 0 && selectorTitleId > 0) &&
                <div style={{ width: 1150 }}>
            {selectorStatsGridDisplay === "SeasonRightPanel" &&
                    <SeasonContractStatsGrid/>}
            {selectorStatsGridDisplay === "EpisodeRightPanel" &&
                    <EpisodeContractStatsGrid/>}
            {selectorStatsGridDisplay  === "ProductRightPanel" &&
                    <GuildContractStatsGrid/>}
                </div>
            }
            {/*{selectorUnstructuredSearchState === true &&*/}
            {/*    <Box*/}
            {/*    sx={{*/}
            {/*    height: 34*/}
            {/*}}/>*/}
            {/*}*/}
            {selectorContractId > 0  &&
                <Stack direction="row" spacing={2}>
                    {selectorContractFoldersDisplay &&
                    <WorkQueueFolders/>}
                    <WorkQueueCDPGrid
                        // selectedSection={contractSectionIdP}
                        // contractIdq={contractIdq}
                        // passSelectedCDP={setSelectedCDPTop}
                        // passShowCDPVDrawer={setShowCDPVDrawerTop}
                        // passContractDataPointId={setContractDataPointId}
                    />
                    {selectorCdpvPivotState  &&
                    <CdpvPivotDrawer/>
                }
                    {selectorCdpvMegaPivotState  &&
                        <CdpvMegaPivotDrawer/>
                    }
                    {selectorCdpvMegaDatePivotState  &&
                        <CdpvMegaDatePivotDrawer/>
                    }


                </Stack>

            }
                </div>
    )
}